// extracted by css-extract-rspack-plugin
export default {"tile":"_4db662b0","info":"_7ac5530a"};